module.exports = require('./helpers/bundle-url').getBundleURL('4KXYA') + "logo-dark.eefe0b7f.svg";